module.exports = __webpack_public_path__ + "img/18.23cb7106.jpg";